import React from 'react';
import {} from 'react-bootstrap';

const Header = () => {
    return (
        <div className="border-bottom">
            <h1 className="text-center p-5 text-success">Bangladesh national cricket team</h1>
        </div>
    );
};

export default Header;